<template>
  <div class="projects-container">
    <h1>Projects</h1>
    <p>A selection of projects I've worked on throughout my engineering journey</p>
    <div class="projects-grid">
      <a v-for="project in projects" :key="project.id" :href="project.repo" target="_blank" class="project-card">
        <img :src="project.image" :alt="project.name" class="project-image">
        <div class="project-info">
          <h2>{{ project.name }}</h2>
          <p>{{ project.description }}</p>
          <div class="project-tags">
            <span v-for="tag in project.tags" :key="tag">{{ tag }}</span>
          </div>
        </div>
      </a>
    </div>
  </div>
  <footer>
      © 2024 Bakir Hamidovic
  </footer>
</template>
  
  
  <script>
  export default {
    name: 'ProjectsPage',
    data() {
      return {
        projects: [
          {
            id: 1,
            name: 'Shared Memory in XV6',
            description: 'Engineered key system upgrades to the XV6 OS...',
            tags: ['C', 'C++', 'Shell', 'Operating Systems'],
            image: '/assets/projects/xv6.png',
            repo: 'https://github.com/habakir/shared-memory-xv6'
          },
          {
            id: 2,
            name: 'Famous Quotes',
            description: 'Developed a Java-based web service for browsing and contributing to a collection of notable quotations...',
            tags: ['Java', 'JSON'],
            image: '/assets/projects/quote.png',
            repo: 'https://github.com/habakir/QuoteTask'
          },
          {
            id: 3,
            name: 'Image Classifier',
            description: 'Leveraged ResNet-18 and ResNet-34 neural networks to create an AI model...',
            tags: ['Python', 'AI'],
            image: '/assets/projects/deeplearning.png',
            repo: 'https://github.com/habakir/Deep-Learning-Image-Classifier'
          },
          {
            id: 4,
            name: 'Raspberry Pico with Ultrasonic Sensor - Prototype',
            description: 'A compact prototype using a 3.3V ultrasonic sensor with a Raspberry Pi Pico...',
            tags: ['Python', 'Firebase', 'Raspberry', 'Sensors'],
            image: '/assets/projects/raspberrypico.png',
            repo: 'https://github.com/habakir/RaspberryPico-Ultrasonic-Firebase'
          },
          {
            id: 5,
            name: 'Web Commerce',
            description: 'Developed a multi-tiered e-commerce platform with a MariaDB-backed admin App Service...',
            tags: ['JavaScript', 'HTML', 'Vue', 'CSS', 'MariaDB'],
            image: '/assets/projects/fullstack.png',
            repo: 'https://github.com/habakir/Web-Commerce'
          }
        ]
      };
    }
  };
  </script>
  
<style scoped>
.projects-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Open Sans', sans-serif;
}

h1 {
  text-align: center;
  font-size: 2.5rem;
  color: #333;
}

p {
  text-align: center;
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem;
}

.project-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  overflow: hidden;
  transition: box-shadow 0.3s, transform 0.3s;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  background: #fff;
}

.project-card:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.project-image-container {
  max-height: 50px;
  overflow: hidden;
}

.project-image {
  width: 100%;
  height:fit-content;
  object-fit: cover;
}

.project-info {
  padding: 1rem;
  text-align: center;
}

.project-info h2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.project-info p {
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.project-tags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.project-tags span {
  background-color: #f2f2f2;
  padding: 0.5rem 1rem;
  border-radius: 15px;
  font-size: 0.85rem;
}

footer {
  color: #333;
  text-align: center;
  padding: 30px 0;
  width: 100%;
  position: static;
  bottom: 0;
}

@media (max-width: 768px) {
  .projects-container {
    padding: 1rem;
  }

  .projects-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  h1 {
    font-size: 2rem;
  }

  p {
    font-size: 1rem;
  }

  .project-info h2 {
    font-size: 1.2rem;
  }

  .project-info p {
    font-size: 0.8rem;
  }

  .project-tags span {
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
  }

  footer {
    padding: 20px 0;
  }
}
</style>